import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toHandlers as _toHandlers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/svg/slice-dip-icon.svg'
import _imports_1 from '@/assets/svg/slice-rotation-icon.svg'


const _hoisted_1 = { class: "slicing-container" }
const _hoisted_2 = {
  key: 0,
  class: "slice-options animated-fast",
  ref: "slice-options"
}
const _hoisted_3 = { class: "p-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa-times fal" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("i")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("j")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("k")
const _hoisted_10 = {
  key: 0,
  class: "custom-slice-inputs"
}
const _hoisted_11 = { class: "custom-slice-input" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "custom-slice-input" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { innerHTML: `Rotation` }, null, -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "slices" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "slice-name" }
const _hoisted_25 = { class: "slice-actions" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  ref: "addSlice",
  class: "add-slice-button"
}
const _hoisted_28 = { style: {"letter-spacing":"1px","color":"inherit","font-size":"0.8em","font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_tab = _resolveComponent("imdex-tab")!
  const _component_imdex_tabs = _resolveComponent("imdex-tabs")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      "enter-active-class": "fadeInUp",
      "leave-active-class": "fadeOutDown"
    }, {
      default: _withCtx(() => [
        (_ctx.editSlice > -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.$t(`ssa.displayPane.slicing.sliceOptions`)) + " ", 1),
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editSlice = -1)),
                  class: "close-options-icon"
                }, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_imdex_tabs, {
                  bubbles: "",
                  value: _ctx.activeSlice.axis,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeSlice.axis) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_imdex_tab, {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.updateSliceAxis(_ctx.activeSlice.id, 0)), ["stop"])),
                      key: 0
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })),
                    (_openBlock(), _createBlock(_component_imdex_tab, {
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.updateSliceAxis(_ctx.activeSlice.id, 1)), ["stop"])),
                      key: 1
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })),
                    (_openBlock(), _createBlock(_component_imdex_tab, {
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.updateSliceAxis(_ctx.activeSlice.id, 2)), ["stop"])),
                      key: 2
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })),
                    (_openBlock(), _createBlock(_component_imdex_tab, {
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.updateSliceAxis(_ctx.activeSlice.id, 3)), ["stop"])),
                      key: 3
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`ssa.displayPane.slicing.custom`)), 1)
                      ]),
                      _: 1
                    }))
                  ]),
                  _: 1
                }, 8, ["value"]),
                (_ctx.activeSlice.axis == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_imdex_tooltip, null, {
                          activator: _withCtx((on) => [
                            _createElementVNode("div", _toHandlers(on), _hoisted_13, 16)
                          ]),
                          tooltip: _withCtx(() => [
                            _createElementVNode("span", {
                              innerHTML: _ctx.$t(`ssa.displayPane.slicing.dip`)
                            }, null, 8, _hoisted_14)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("input", {
                          type: "number",
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeNormal(_ctx.activeSlice.id, 'dip', $event))),
                          value: _ctx.activeSlice.dip
                        }, null, 40, _hoisted_15)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_imdex_tooltip, null, {
                          activator: _withCtx((on) => [
                            _createElementVNode("div", _toHandlers(on), _hoisted_18, 16)
                          ]),
                          tooltip: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }),
                        _createElementVNode("input", {
                          type: "number",
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeNormal(_ctx.activeSlice.id, 'azimuth', $event))),
                          value: _ctx.activeSlice.azimuth
                        }, null, 40, _hoisted_20)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_21, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slices, (slice, i) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (_ctx.activateSlice(slice.id)),
          class: _normalizeClass(["slice-item", { active: slice.active }]),
          ref_for: true,
          ref: `slice-${i}`,
          key: i
        }, [
          _createElementVNode("i", {
            onClick: _withModifiers(($event: any) => (_ctx.openSliceOptions(i)), ["stop"]),
            class: "fa fa-pencil edit-slice-icon"
          }, null, 8, _hoisted_23),
          _createElementVNode("div", _hoisted_24, _toDisplayString(slice.name || `${_ctx.sliceNameMap[slice.axis]} Slice`), 1),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("i", {
              class: _normalizeClass(["fa edit-slice-icon", { 'fa-eye': slice.active, 'fa-eye-slash ': !slice.active }])
            }, null, 2),
            _createElementVNode("i", {
              onClick: _withModifiers(($event: any) => (_ctx.removeSlice(slice.id)), ["stop"]),
              class: "fal fa-times edit-slice-icon"
            }, null, 8, _hoisted_26)
          ])
        ], 10, _hoisted_22))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_imdex_btn, {
        mini: "",
        disabled: !_ctx.canAddSlices,
        onClick: _ctx.addSlice,
        secondary: "",
        text: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t(`ssa.displayPane.slicing.addSlice`)), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ], 512)
  ]))
}